import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WarehouseCreatePage } from '@/features/data/warehouses/warehouse-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvel entrepôt SQL (porting README #74) : schéma Trino de la plateforme ou base externe. */
export const Route = createFileRoute('/$tenant/sql/new')({ component: WarehouseCreateRoute });

function WarehouseCreateRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="sql"
      crumbs={[{ label: t('nav.items.sql') }, { label: t('warehouseManage.new') }]}
    >
      <WarehouseCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
